/* tslint:disable */

declare var Object: any;
export interface DiscountRequestInterface {
  "partnerId": string;
  "requestor": number;
  "creditTerms"?: number;
  "merchantType": string;
  "paymentType": string;
  "productType": string;
  "rate": number;
  "unit": string;
  "endDate": Date;
  "dateCreated": Date;
  "id"?: number;
  user?: any;
}

export class DiscountRequest implements DiscountRequestInterface {
  "partnerId": string;
  "requestor": number;
  "creditTerms": number;
  "merchantType": string;
  "paymentType": string;
  "productType": string;
  "rate": number;
  "unit": string;
  "endDate": Date;
  "dateCreated": Date;
  "id": number;
  user: any;
  constructor(data?: DiscountRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DiscountRequest`.
   */
  public static getModelName() {
    return "DiscountRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DiscountRequest for dynamic purposes.
  **/
  public static factory(data: DiscountRequestInterface): DiscountRequest{
    return new DiscountRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DiscountRequest',
      plural: 'DiscountRequests',
      path: 'DiscountRequests',
      idName: 'id',
      properties: {
        "partnerId": {
          name: 'partnerId',
          type: 'string'
        },
        "requestor": {
          name: 'requestor',
          type: 'number'
        },
        "creditTerms": {
          name: 'creditTerms',
          type: 'number'
        },
        "merchantType": {
          name: 'merchantType',
          type: 'string'
        },
        "paymentType": {
          name: 'paymentType',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "rate": {
          name: 'rate',
          type: 'number',
          default: 0
        },
        "unit": {
          name: 'unit',
          type: 'string'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'requestor',
          keyTo: 'id'
        },
      }
    }
  }
}
